import Tooltip from '@mui/material/Tooltip'
import { FC, useMemo } from 'react'
import { ModelSpecialization } from '../../../../swagger/dto'
import CodeIcon from './../../../../assets/icons/Code.svg?react'
import LightBulbIcon from './../../../../assets/icons/LightBulb.svg?react'
import PapetteIcon from './../../../../assets/icons/Papette.svg?react'
import StarIcon from './../../../../assets/icons/Star.svg?react'
import TablerIconChartHistogramIcon from './../../../../assets/icons/TablerIconChartHistogram.svg?react'

interface Props {
    specialization?: string
}

export const ModelSpecializationIcon: FC<Props> = ({ specialization, style }) => {
    const specializationIcon = useMemo(() => {
        switch (specialization) {
            case ModelSpecialization.Analysis:
                return (
                    <Tooltip title="Модели для аналитики и выводов с упором на доступность и эффективность">
                        <span>
                            <TablerIconChartHistogramIcon style={style} />
                        </span>
                    </Tooltip>
                )

            case ModelSpecialization.Art:
                return (
                    <Tooltip title="Модели с акцентом на креатив и творческую генерацию текстов">
                        <span>
                            <PapetteIcon style={style} />
                        </span>
                    </Tooltip>
                )

            case ModelSpecialization.Coding:
                return (
                    <Tooltip title="Оптимальны для программирования, генерации и анализа кода">
                        <span>
                            <CodeIcon style={style} />
                        </span>
                    </Tooltip>
                )

            case ModelSpecialization.Research:
                return (
                    <Tooltip title="Лучшие в решении комплексных задач, требующих логики, рассуждения, веб-поиска">
                        <span>
                            <LightBulbIcon style={style} />
                        </span>
                    </Tooltip>
                )

            case ModelSpecialization.Universal:
                return (
                    <Tooltip title="Гибридные, мультизадачные модели — сильны в большинстве сценариев: диалог, анализ, генерация, код, творчество">
                        <span>
                            <StarIcon style={style} />
                        </span>
                    </Tooltip>
                )
        }
    }, [specialization])

    return specializationIcon
}
